import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

interface AuthProps extends React.Props<{}> {
  auth: any;
  authActions: any;
}

export default class Auth extends React.Component<AuthProps, {}> {
  static propTypes = {
    auth: PropTypes.any.isRequired,
    authActions: PropTypes.any.isRequired,
  };

  render() {
    return (
      this.props.auth.isAuthenticated ? ( <Route children={this.props.children} />  ) : ( <Redirect to="/" /> )
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Auth.tsx